import { getLayerDefinition } from "../../../evergis/core/layer/getLayerDefinition";
import { formatAttributeValue } from "../../../utils/formatAttributeValue";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { ConfigRelatedDataSource } from "../types";

export const formatChartRelatedValue = (
  value: string | number,
  layerInfo: LayerInfo,
  relatedAttributes: ConfigRelatedDataSource[],
) => {
  const layerDefinition = getLayerDefinition(layerInfo);
  const relatedAxis = relatedAttributes.find(({ chartAxis }) => chartAxis === "y");
  const attribute = layerDefinition.attributes[relatedAxis.attributeName];

  return attribute ? formatAttributeValue(attribute.type, value, attribute.stringFormat) : value;
};
